module.exports = __webpack_public_path__ + "img/kommune-2012.667eaf97.svg";